module.exports = __webpack_public_path__ + "img/head.95138c0d.png";